import type { IEnvConfig } from '../types';
import { roundThemeFormat } from './helpers';

export const checkpointConfig: IEnvConfig = {
  name: 'checkpoint',
  survey: {
    callbackURL: 'https://games-user-research.qq.com/api/v1/callback/survey',
  },
  desktop: {
    namespace: 'games-user-research',
    versionLabel: 'Checkpoint',
    hasTestEnv: false, // checkpoint 不存在测试环境
  },
  cos: {
    bucket: 'uxlab-london-1253502009',
    region: 'eu-frankfurt',
  },
  group: {
    groupBy: 'round',
    groupIdField: 'round_id',
    themeFormat: roundThemeFormat,
  },
  ui: {
    bodyClass: 'pteam',
    cardPTeamClass: true,
    subtitleDuration: 6,
    dateFormat: 'dd-MMM-yy HH:mm:ss',
    defaultPlayerMode: 1,
    loginIconType: 'checkpoint',
    sloganStyle: 'pteam',
  },
  features: {
    enableBeacon: false,
    enableAegis: false,
    showTopText: false,
    showUsageReason: false,
    showRoundSelect: true,
    showOperationGuide: false,
    showRemoteControl: false,
    canEditProductName: true,
    canEditProductOwner: true,
    canEditRound: true,
    showSessionCount: true,
    showRegisterHint: false,
    showLoginFooter: true,
    showThemeInClassify: false,
    showGroupVideoLayout: false,
    showDualShareLinks: false,
    showDeviceEquipment: false,
    showUsageNotice: false,
    showMobileTipsBar: false,
    isAggregatedByUnionId: false,
    showProjectAssociation: false,
    usePusherScheme1080p: false,
    showThemeRequiredForMultipleSessions: false,
    showMultiPusher: true,
    showPlayerInfoDialog: true, // 海外版保留「设备和玩家信息」弹窗
    showMaterialTest: false, // 与萨罗斯一致：无素材测试入口
    showCloudCE: false, // 与萨罗斯一致：无云端CE入口
    showAsrLangSwitch: false, // 与萨罗斯一致：只保留基础中英识别
    showCaptionTranslation: false, // 与萨罗斯一致：取消翻译栏
    showBorrowableDevice: false,
    showSmartSummary: false,
  },
  text: {
    appTitle: 'Games User Research Streaming Platform',
    adminContact: 'checkpoint@tencent.com',
    adminContactLink: 'mailto://checkpoint@tencent.com',
    adminEmail: 'checkpoint@tencent.com',
    accountLabel: '邮箱',
    copySuccessMessage: 'Copied to clipboard',
    inviteSuccessMessage: 'Copied to clipboard',
    shareSuccessMessage: 'Copied to clipboard',
    registerHint: '',
    waitApprovalHint: '',
    checkEmailHint: '',
    nonTencentUserHint: 'You will need to register with an account.',
    contactAdminHint: '',
    labContactTip: 'If the number of stations does not meet the demand, please contact checkpoint@tencent.com',
    sloganDesc: 'IEGG - Checkpoint',
  },
};
